import { l as e } from "./image.service-BZ-WQOP-.js";
import { watch as t } from "vue";
import { resetDateTimeUnits as n } from "@editor/ui-utils";
import { defineStore as r } from "pinia";
//#region \0rolldown/runtime.js
var i = Object.create, a = Object.defineProperty, o = Object.getOwnPropertyDescriptor, s = Object.getOwnPropertyNames, c = Object.getPrototypeOf, l = Object.prototype.hasOwnProperty, u = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), d = (e, t) => {
	let n = {};
	for (var r in e) a(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || a(n, Symbol.toStringTag, { value: "Module" }), n;
}, f = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = s(t), c = 0, u = i.length, d; c < u; c++) d = i[c], !l.call(e, d) && d !== n && a(e, d, {
		get: ((e) => t[e]).bind(null, d),
		enumerable: !(r = o(t, d)) || r.enumerable
	});
	return e;
}, p = (e, t, n) => (n = e == null ? {} : i(c(e)), f(t || !e || !e.__esModule ? a(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), m;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.FITFORFUN = "fitforfun", e.FINANZEN100 = "finanzen100", e.MITTIER = "mittier", e.MITSTERNEN = "mitsternen", e.MITBEZIEHUNG = "mitbeziehung", e.TVTODAY = "tvtoday", e.TVSPIELFILM = "tvspielfilm";
})(m ||= {}), Object.freeze(m);
var h;
(function(e) {
	e.BUNTE = "bunte", e.CHIP = "chip", e.FOCUS = "focus", e.PRAXISTIPPS = "praxistipps";
})(h ||= {}), Object.freeze(h), Object.freeze([
	m.MITTIER,
	m.MITSTERNEN,
	m.MITBEZIEHUNG,
	m.TVTODAY,
	m.TVSPIELFILM
]), Object.freeze({
	[m.BUNTE]: "bunte",
	[m.CHIP]: "chip",
	[m.FOCUS]: "focus",
	[m.FITFORFUN]: "fitforfun",
	[m.FINANZEN100]: "finanzen100",
	[m.MITTIER]: "default-verticals",
	[m.MITSTERNEN]: "default-verticals",
	[m.MITBEZIEHUNG]: "default-verticals",
	[m.TVTODAY]: "default",
	[m.TVSPIELFILM]: "default"
}), Object.freeze(Object.values(m)), Object.freeze(Object.values(h)), m.BUNTE, m.CHIP, m.FOCUS, m.FITFORFUN, m.TVSPIELFILM, m.TVTODAY, m.BUNTE, m.CHIP, m.FOCUS, m.FITFORFUN, m.TVSPIELFILM, m.TVTODAY;
//#endregion
//#region ../../../framework/ctf-config/dist/generalEnums.js
var g;
(function(e) {
	e.LOCAL = "local", e.LOCAL_K8S = "local_k8s", e.LOCAL_E2E = "local_e2e", e.SANDBOX = "sandbox", e.DEVELOPMENT = "development", e.STAGING = "staging", e.PRODUCTION = "production", e.TEST = "test";
})(g ||= {});
//#endregion
//#region ../../../framework/ctf-config/dist/configHelper.js
function _(e) {
	return v(e);
}
function v(e) {
	return Object.getOwnPropertyNames(e).forEach((t) => {
		let n = e[t];
		n && (typeof n == "object" || typeof n == "function") && !Object.isFrozen(n) && v(n);
	}), Object.freeze(e);
}
function y(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function b(e) {
	return y(e);
}
function x(e) {
	return y(e);
}
function S(e) {
	return typeof e == "function";
}
function C(e) {
	return Object.fromEntries(Object.entries(e));
}
function w(e, t) {
	let n = {}, r = C(t), i = C(e);
	for (let e of Object.keys({
		...r,
		...i
	})) {
		let t = r[e], a = i[e];
		y(t) && x(a) ? n[e] = w(a, t) : S(a) ? n[e] = a.bind(n) : S(t) ? n[e] = t.bind(n) : e in i ? n[e] = a : n[e] = t;
	}
	if (!b(n)) throw Error("merged config is not an object");
	return n;
}
function T(e) {
	if (typeof process < "u") {
		let t = process.env[e];
		if (t !== void 0) return t;
	}
}
function E(e) {
	return Object.values(g).find((t) => t === e) !== void 0;
}
function D() {
	let e = process.env.APP_ENV;
	if (e === void 0) throw Error("APP_ENV is undefined.\nHint: configuration should be initialized lazily during runtime and not during build time.");
	if (!E(e)) throw Error(`APP_ENV=${e}. Allowed values=${Object.values(g).join(", ")}`);
	return e;
}
var O = /* @__PURE__ */ new WeakMap();
function k(e) {
	let t = O.get(e);
	if (b(t)) return t;
	let { base: n, ...r } = e, i;
	i = typeof process > "u" ? r.local : r[D()];
	let a = _(i ? w(i, n) : n);
	return O.set(e, a), a;
}
//#endregion
//#region ../../../framework/ctf-config/dist/configs/limits.config.js
var A = {
	window: 300 * 1e3,
	count: 5e3
}, j = {
	...A,
	count: 1e4
}, M = {
	base: {
		apiRateLimit: {
			window: 300 * 1e3,
			count: 2e3
		},
		apiUploads: {
			jsonPayload: 50 * 1024 * 1024,
			multipartFormFile: 10 * 1024 * 1024
		},
		backend: { remoteImageDownload: 10 * 1024 * 1024 }
	},
	local: { apiRateLimit: j },
	local_k8s: { apiRateLimit: j },
	local_e2e: { apiRateLimit: j },
	test: { apiRateLimit: A },
	sandbox: { apiRateLimit: A }
}, N = () => k(M), P = () => ({
	title: "",
	caption: "",
	source: "",
	height: 0,
	width: 0,
	credits: "",
	focalPointX: 0,
	focalPointY: 0,
	publishDate: void 0,
	unpublishDate: void 0,
	isDeleted: !1,
	isPartnerImage: !1,
	createDate: n(/* @__PURE__ */ new Date()),
	changeDate: n(/* @__PURE__ */ new Date()),
	state: "draft",
	license: [],
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	}
}), F = r("image", {
	state: () => ({
		doc: P(),
		uploadedFile: void 0,
		blob: void 0,
		imageInstance: void 0,
		squarePreviewSrc: void 0,
		widePreviewSrc: void 0,
		ultraWidePreviewSrc: void 0
	}),
	getters: { url() {
		return this.blob ? this.blob : !this.doc._id || !this.doc.source ? "" : e(this.doc._id, this.doc.width, this.doc.height);
	} },
	actions: {
		clearBlobData() {
			this.blob = void 0, this.uploadedFile = void 0, this.imageInstance = void 0, this.squarePreviewSrc = void 0, this.widePreviewSrc = void 0, this.ultraWidePreviewSrc = void 0;
		},
		clearAll() {
			this.clearBlobData(), this.doc = P();
		}
	}
}), I = () => F(), L = () => {
	let e = F();
	return t(() => e.uploadedFile, (t) => {
		if (!t) return;
		let n = new FileReader();
		n.onload = () => {
			let t = new Image();
			t.onload = () => {
				e.doc = {
					...e.doc,
					width: t.naturalWidth,
					height: t.naturalHeight
				}, e.imageInstance = t;
			};
			let r = n.result?.toString() || "";
			e.blob = r, t.src = r;
		}, n.readAsDataURL(t);
	}), t(() => e.doc._id, (t, n) => {
		!t && n && e.clearAll();
	}), e;
}, R = (e, t) => {
	let n = L();
	n.doc = {
		...n.doc,
		...e
	}, n.uploadedFile = t;
}, z = new (/* @__PURE__ */ p((/* @__PURE__ */ u(((e, t) => {
	var n = Object.prototype.hasOwnProperty, r = "~";
	function i() {}
	Object.create && (i.prototype = Object.create(null), new i().__proto__ || (r = !1));
	function a(e, t, n) {
		this.fn = e, this.context = t, this.once = n || !1;
	}
	function o(e, t, n, i, o) {
		if (typeof n != "function") throw TypeError("The listener must be a function");
		var s = new a(n, i || e, o), c = r ? r + t : t;
		return e._events[c] ? e._events[c].fn ? e._events[c] = [e._events[c], s] : e._events[c].push(s) : (e._events[c] = s, e._eventsCount++), e;
	}
	function s(e, t) {
		--e._eventsCount === 0 ? e._events = new i() : delete e._events[t];
	}
	function c() {
		this._events = new i(), this._eventsCount = 0;
	}
	c.prototype.eventNames = function() {
		var e = [], t, i;
		if (this._eventsCount === 0) return e;
		for (i in t = this._events) n.call(t, i) && e.push(r ? i.slice(1) : i);
		return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(t)) : e;
	}, c.prototype.listeners = function(e) {
		var t = r ? r + e : e, n = this._events[t];
		if (!n) return [];
		if (n.fn) return [n.fn];
		for (var i = 0, a = n.length, o = Array(a); i < a; i++) o[i] = n[i].fn;
		return o;
	}, c.prototype.listenerCount = function(e) {
		var t = r ? r + e : e, n = this._events[t];
		return n ? n.fn ? 1 : n.length : 0;
	}, c.prototype.emit = function(e, t, n, i, a, o) {
		var s = r ? r + e : e;
		if (!this._events[s]) return !1;
		var c = this._events[s], l = arguments.length, u, d;
		if (c.fn) {
			switch (c.once && this.removeListener(e, c.fn, void 0, !0), l) {
				case 1: return c.fn.call(c.context), !0;
				case 2: return c.fn.call(c.context, t), !0;
				case 3: return c.fn.call(c.context, t, n), !0;
				case 4: return c.fn.call(c.context, t, n, i), !0;
				case 5: return c.fn.call(c.context, t, n, i, a), !0;
				case 6: return c.fn.call(c.context, t, n, i, a, o), !0;
			}
			for (d = 1, u = Array(l - 1); d < l; d++) u[d - 1] = arguments[d];
			c.fn.apply(c.context, u);
		} else {
			var f = c.length, p;
			for (d = 0; d < f; d++) switch (c[d].once && this.removeListener(e, c[d].fn, void 0, !0), l) {
				case 1:
					c[d].fn.call(c[d].context);
					break;
				case 2:
					c[d].fn.call(c[d].context, t);
					break;
				case 3:
					c[d].fn.call(c[d].context, t, n);
					break;
				case 4:
					c[d].fn.call(c[d].context, t, n, i);
					break;
				default:
					if (!u) for (p = 1, u = Array(l - 1); p < l; p++) u[p - 1] = arguments[p];
					c[d].fn.apply(c[d].context, u);
			}
		}
		return !0;
	}, c.prototype.on = function(e, t, n) {
		return o(this, e, t, n, !1);
	}, c.prototype.once = function(e, t, n) {
		return o(this, e, t, n, !0);
	}, c.prototype.removeListener = function(e, t, n, i) {
		var a = r ? r + e : e;
		if (!this._events[a]) return this;
		if (!t) return s(this, a), this;
		var o = this._events[a];
		if (o.fn) o.fn === t && (!i || o.once) && (!n || o.context === n) && s(this, a);
		else {
			for (var c = 0, l = [], u = o.length; c < u; c++) (o[c].fn !== t || i && !o[c].once || n && o[c].context !== n) && l.push(o[c]);
			l.length ? this._events[a] = l.length === 1 ? l[0] : l : s(this, a);
		}
		return this;
	}, c.prototype.removeAllListeners = function(e) {
		var t;
		return e ? (t = r ? r + e : e, this._events[t] && s(this, t)) : (this._events = new i(), this._eventsCount = 0), this;
	}, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, t !== void 0 && (t.exports = c);
})))(), 1)).default(), B = () => z;
//#endregion
export { N as a, d as c, L as i, I as n, T as o, R as r, m as s, B as t };

//# sourceMappingURL=eventBus-BwFpUh5d.js.map